import { AuthBaseClient } from '../base-client';
import { agentComponentCatalogSchema, type AgentComponentCatalog } from './types';

/**
 * Client for the conversation builder's component catalog
 * (`/api/agent-components`). The response is Zod-parsed at the boundary.
 */
export class AgentComponentsClient extends AuthBaseClient {
  /** Every step the builder may offer, plus the org's option lists. */
  async getCatalog(signal?: AbortSignal): Promise<AgentComponentCatalog> {
    const raw = await this.get<unknown>('/api/agent-components', signal);
    return agentComponentCatalogSchema.parse(raw);
  }
}
